import CouponList from "./CouponList";
import CouponIcon from "@mui/icons-material/Receipt";

const coupons = {
  list: CouponList,
  icon: CouponIcon,
};

export default coupons;
